var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"page-title text-center"},[_vm._v(_vm._s(_vm.formatType !== 'Review' ? 'My Reports' : _vm.formatType))]),_c('table-box',{attrs:{"columns":_vm.columnsForDraft,"rows":_vm.draftedChecklists,"baseUrl":_vm.baseUrl,"loading":_vm.loading,"emptyText":"No checklist found","showAdd":false},on:{"open":_vm.onView}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }